<div class="ivd">

  @if (!loaded) {
    <div class="ivd__empty">
      <mat-spinner diameter="24" />
    </div>
  }

  @if (loaded) {
    <div class="ivd__grid">

      @for (key of SLOT_KEYS; track key) {
        <div class="ivd__col">

          <div class="ivd__bar">
            <span class="ivd__slot-label">{{ SLOT_CONFIGS[key].label }}</span>

            <!-- Hidden file input for upload — one per slot -->
            <input #fileInput
                   type="file"
                   accept="image/*"
                   style="display:none"
                   (change)="uploadDocument(key, $event)" />

            <itfg-mat-tab-menu class="ivd__menu-btn">
              <div trigger>
                <mat-icon>more_horiz</mat-icon>
              </div>
              <div content>

                <!-- Upload -->
                <button mat-menu-item (click)="fileInput.click()">
                  <mat-icon>upload</mat-icon>
                  <span>Upload new</span>
                </button>

                <!-- Download -->
                <button mat-menu-item
                        [disabled]="!selectedDocs[key]"
                        (click)="downloadDocument(key)">
                  <mat-icon>download</mat-icon>
                  <span>Download</span>
                </button>

                <!-- Rotate CW -->
                <button mat-menu-item
                        [disabled]="!selectedDocs[key]"
                        (click)="rotateDocument(key, true)">
                  <mat-icon>rotate_right</mat-icon>
                  <span>Rotate clockwise</span>
                </button>

                <!-- Rotate CCW -->
                <button mat-menu-item
                        [disabled]="!selectedDocs[key]"
                        (click)="rotateDocument(key, false)">
                  <mat-icon>rotate_left</mat-icon>
                  <span>Rotate counter-clockwise</span>
                </button>

                <!-- Delete -->
                <button mat-menu-item
                        [disabled]="!selectedDocs[key]"
                        (click)="deleteDocument(key)">
                  <mat-icon color="warn">delete</mat-icon>
                  <span class="ivd__action--danger">Delete</span>
                </button>

              </div>
            </itfg-mat-tab-menu>
          </div>

          <div class="ivd__viewer-wrap">
            <itfg-identity-document-viewer
              [client]="client"
              [label]="SLOT_CONFIGS[key].label"
              [documentType]="SLOT_CONFIGS[key].apiType"
              [selectedDocId]="detail?.[SLOT_CONFIGS[key].docKey] ?? null"
              (documentSelected)="onDocumentSelected(key, $event)"
            >
            </itfg-identity-document-viewer>
          </div>

          <div class="ivd__bar">
            <mat-menu #invalidMenu="matMenu" xPosition="after">
              <div class="ivd__menu-header">Invalidate</div>
              @for (reason of INVALIDATION_REASONS; track reason) {
                <button mat-menu-item (click)="invalidateDocument(key, reason)">
                  <span>{{ formatDocumentReason(reason) }}</span>
                </button>
              }
            </mat-menu>

            <div class="ivd__status-chip ivd__status-chip--{{ slotStatusClass(key) }}"
                [class.ivd__status-chip--actionable]="isActionable(key)"
                [matMenuTriggerFor]="isActionable(key) ? invalidMenu : null"
                [matTooltip]="isActionable(key) ? 'Change status' : null"
                matTooltipPosition="above">
              <mat-icon class="ivd__status-icon">{{ slotStatusIcon(key) }}</mat-icon>
              {{ slotStatusLabel(key) }}
              @if (isActionable(key)) {
                <mat-icon class="ivd__status-icon ivd__status-arrow">arrow_drop_down</mat-icon>
              }
            </div>
            @if (slotReason(key)) {
              <div class="ivd__reason">
                <mat-icon class="ivd__reason-icon">warning</mat-icon>
                {{ slotReason(key) }}
              </div>
            }
          </div>

        </div>
      }

    </div>
  }

</div>